import { ERROR_CONTRACTS, GET_CONTRACTS, UNATORIZED } from "./types";
import i18n from "i18next";

export const ContractsReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_CONTRACTS:
            return {
                ...state,
                contracts: payload,
                isFetching: false,
                error: false,
                tokenError: false
            }
        case ERROR_CONTRACTS:
            return {
                ...state,
                isFetching: false,
                error: true,
                message: i18n.t('common.error_server'),
            }
        case UNATORIZED:
            return {
                ...state,
                isFetching: false,
                error: true,
                message: i18n.t('common.error_token'),
                tokenError: true
            }
        default:
            return state
    }
}
